import cookie from 'react-cookies';

const UserLogout = () => {
    cookie.remove('token', {path: '/'});
    window.location.href = '/login'
};

export default UserLogout;
